<div>
@if (!dataLoading && dataSourceLength) {
  <div class="table-scroll-container" [ngClass]="{ 'no-data-height': isEmptyTable, 'rvt-table': pageName === 'rvtResults' || pageName === 'releasePackView', 'base-image-table': pageName === 'environmentBaseImage' }">
  <table mat-table [dataSource]="pageDataSource" matSort (matSortChange)="sortData($event)" class="mat-elevation-z1 sticky-table" multiTemplateDataRows>
    @for (tableColumn of displayColumns; track tableColumn?.key) {
      @if (tableColumn.type === 'components') {
        <ng-container [matColumnDef]="tableColumn?.key">
          <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear [disabled]="!tableColumn?.sortable" class="fs-14 fw-700">
            {{ tableColumn?.name | uppercase }}
          </th>
          <td mat-cell *matCellDef="let data" class="fw-400 fs-16">
            <div class="flex flex-row items-center gap-1"> 
              @if (data.status === 'inprogress') {
                <mat-spinner diameter="16" class="mr-8 progress-color" mode="indeterminate"></mat-spinner>
              } @else {
                <mat-icon [svgIcon]="data.status === 'success' ? 'check_circle_filled': data.status === 'failed'? 'error_filled': ''" class="icon-sm" [ngClass]="{'success-icon': data.status === 'success','failed-icon': data.status === 'failed'}"></mat-icon>
              }
               {{ data[tableColumn?.key] ? data[tableColumn?.key] : '-' }}
            </div>
          </td>
        </ng-container>
      }
      @if (tableColumn.type === 'estimatedTime') {
        <ng-container [matColumnDef]="tableColumn?.key">
          <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear [disabled]="!tableColumn?.sortable" class="fs-14 fw-700 align-right">
            {{ tableColumn?.name | uppercase }}
          </th>
          <td mat-cell *matCellDef="let data" class="estimatedTime align-right" [ngClass]="{'success-icon': data[tableColumn?.key] === 'Completed','failed-icon': data[tableColumn?.key] === 'Failed' || data[tableColumn?.key] === 'Threshold Reached'}">
            <div class="flex flex-row items-center gap-1"> 
            @if(data[tableColumn?.key] === 'Threshold Reached') {
              <mat-icon  class="icon-sm warn" svgIcon="warning_amber"></mat-icon>
            }
            {{ data[tableColumn?.key] ? data[tableColumn?.key] !== 'Completed' ? data[tableColumn?.key]  : '' : '-'}}
            @if((data.status === 'success' || data.status === 'failed') && data.timeLeft){
              <div class="flex items-center p-6 h-24" [ngClass]="{'success-text': data[tableColumn?.key] === 'Completed','failed-text': data[tableColumn?.key] === 'Failed'}">{{data.timeLeft}}</div>
            }
            </div>
          </td>
        </ng-container>
      }
      @if (tableColumn.type === 'descriptionIcon') {
      <ng-container [matColumnDef]="tableColumn?.key">
        <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear [disabled]="!tableColumn?.sortable"> {{ tableColumn?.name | uppercase }} </th>
        <td mat-cell *matCellDef="let data" class="w-1/12 text-left py-2">
          <div class="icon-position" *ngIf="tableColumn.key === 'details'">
            <button class="pl-4 pr-8 description-icon mr-8" (click)="viewKubernetes(data)">
              <mat-icon svgIcon="description" class="cursor-pointer"></mat-icon>
            </button>
          </div>
        </td>
      </ng-container>
      }
     @if (tableColumn.type === 'radioSelection') {
      <ng-container [matColumnDef]="tableColumn?.key">
        <th mat-header-cell *matHeaderCellDef [disabled]="!tableColumn?.sortable" class="text-left py-2 font-medium radio-column"> {{ tableColumn?.name | uppercase }} </th>
          <td mat-cell *matCellDef="let data" class="text-left py-2">
            <!-- For updateServiceDefinition page only -->
            <ng-container *ngIf="pageName === 'updateServiceDefinition'; else otherPages">
              <mat-icon *ngIf="data.disableSelection; else radioEnabledUpdate"
                        svgIcon="radio_button_unchecked"
                        class="icon-md cursor-not-allowed disabled mr-8">
              </mat-icon>
              <ng-template #radioEnabledUpdate>
                <mat-icon *ngIf="!data[tableColumn?.key]"
                          (click)="radioClick(data)"
                          svgIcon="radio_button_unchecked"
                          class="icon-md cursor-pointer mr-8">
                </mat-icon>
                <mat-icon *ngIf="data[tableColumn?.key]"
                          (click)="radioClick(data)"
                          svgIcon="radio_button_checked"
                          class="icon-md cursor-pointer mr-8">
                </mat-icon>
              </ng-template>
            </ng-container>

            <!-- For all other pages -->
            <ng-template #otherPages>
              <mat-icon [ngClass]="{disabled : data.actionInprogress || data.isApplied || data?.isLowerVersion|| (pageName === 'rvtResults' && !instanceInprogress) || ((pageName === 'releasePackage' || pageName === 'rvtPackage' || pageName === 'localConfiguration') && data.disableSelection)}" [svgIcon]="!data[tableColumn?.key] ? 'radio_button_unchecked' : 'radio_button_checked'" class="icon-md cursor-pointer mr-8" (click)="pageName === 'rvtResults' ? rvtClick(data) : radioClick(data)"></mat-icon>            </ng-template>
          </td>
        </ng-container>
      }

      @if (tableColumn.type === 'expand') {
        <ng-container [matColumnDef]="tableColumn?.key">
          <th mat-header-cell *matHeaderCellDef class="text-left py-2 font-medium expand-column" [ngClass]="{'expand': (!dataLoading && (!dataSource || dataSource?.length === 0) && (searchText?.length >= 0 || !searchText))}"> {{ tableColumn?.name | uppercase }} </th>
          <td mat-cell *matCellDef="let data" class="expand text-left py-2">
              <button class="flex justify-center items-center context-menu-icon pl-6 pr-6 cursor-pointer expand-column" (click)="onExpandArrowClick(data); $event.stopPropagation()">
                <mat-icon [svgIcon]="!data.arrowClick ? 'chevron_right' : 'expand_more'" class="relative-class"></mat-icon>
              </button>
          </td>
        </ng-container>
      }
      @if (tableColumn.type === 'text') {
        <ng-container [matColumnDef]="tableColumn?.key">
          <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear [disabled]="!tableColumn?.sortable" class="fs-14 fw-700">
            {{ tableColumn?.name | uppercase }}
          </th>
          <td mat-cell *matCellDef="let data" class="fw-500 fs-16">
            <div class="flex flex-row items-center gap-1 action-row-relative">
            <span class="fw-400 fs-16" [ngClass]="{'ellipsis': tableColumn?.key !== 'ticketNumber' && pageName !== 'environmentBaseImage', 'wrap-text': tableColumn?.key === 'ticketNumber', 'clickable': data[tableColumn?.keyLink] || tableColumn?.keyLink === 'navigation' || tableColumn?.keyLink === 'popup' || (tableColumn?.key === 'version' && pageName === 'updateServiceDefinition') || (pageName === 'environmentBaseImage' && tableColumn?.key === 'name') || (pageName === 'activity' && tableColumn?.key === 'action'), 'max-w-[300px]':(tableColumn?.key === 'name' && data[tableColumn?.key]?.length > 32 && pageName !== 'environmentBaseImage')}" (click)="pageName === 'activity' && tableColumn?.key === 'action' ? rowClicked.emit(data) : (pageName === 'environmentBaseImage' && tableColumn?.key === 'name' ? nameClick.emit(data) : (tableColumn?.key === 'version' && pageName === 'updateServiceDefinition' ? versionClick.emit(data) : (tableColumn?.keyLink === 'navigation' ? popupOpen(data, tableColumn?.key) : pageName === 'runbook' ? runbookPopup(data) : '')))" matTooltipPosition="above" [matTooltip]="(tableColumn?.key === 'name' || tableColumn?.key === 'runbookName' || tableColumn?.key === 'scheduleName') && data[tableColumn?.key]?.length > 32 && pageName !== 'environmentBaseImage' ? data[tableColumn?.key] : ''" [matTooltipClass]="(tableColumn?.key === 'name' || tableColumn?.key === 'runbookName' || tableColumn?.key === 'scheduleName') ? 'tooltip-inner above runbook-name' : 'tooltip-inner left account-db'">
                {{ (tableColumn?.key === 'version' && pageName === 'updateServiceDefinition') ? 'Version ' + data[tableColumn?.key] : ((data[tableColumn?.key]?.length > 32 && tableColumn?.key !== 'ticketNumber' && pageName !== 'environmentBaseImage') ? ((data[tableColumn?.key] | titlecase) | slice:0:32) + '…' : (tableColumn?.key === 'stageName' ? (data[tableColumn?.key]) : data[tableColumn?.key] ? (data[tableColumn?.key] | titlecase) : '-'))}}
            </span>
            @if ((pageName === 'releasePackView' || pageName === 'releasePackage') && tableColumn?.key === 'name') {
              
              @if (data?.codeResult) {
                <div class="code-package ml-16" >
                  <mat-icon svgIcon="integration_instructions" [matTooltip]="'INSTANCE_SUMMARY.UPDATE_CONFIGURATION.CODE_PACKAGE_AVAILABLE' | transloco | titlecase"
                    matTooltipPosition="above" matTooltipClass="tooltip-inner above pt-12 pr-16 pb-12 pl-16 fs-16" class="icon-md-1"></mat-icon>
                  </div>
              }
              @if (data?.hotfix === true) {
                <button class="flex flex-row jutsify-center items-center hotfix mt-4 ml-16 h-16 w-55 fw-700 fs-10 cursor-default">{{'BUTTONS.HOTFIX' | transloco}}</button>
              }
              
            }
            @if (tableColumn?.key === 'name' && data.isManaged === 'No') {
            <span class="tag-thirdparty fw-500 ml-24">{{'INVENTORY.THIRD_PARTY' | transloco}}</span>
            }
            <span class="stage-info-tooltip" [matTooltip]="data[tableColumn?.key]" matTooltipPosition="right" matTooltipClass="tooltip-inner right account-db">
              <mat-icon *ngIf="showStageInfoIcon && tableColumn?.key === 'stageName'" class="info-icon" svgIcon="info"></mat-icon>
            </span>
            @if (pageName === 'runbook' && tableColumn?.key === 'name' && data?.targets?.primary?.targetADOPipeline?.pipelineId) {
              <a href="javascript:void(0);" (click)="openExternalLink(data?.targets?.primary?.targetADOPipeline?.pipelineId)" class="flex items-center gap-1 ado-pipeline">
                <mat-icon svgIcon="open_in_new" class="icon-sm"></mat-icon>
                <span class="fw-400 fs-16">{{ 'ADD_INSTANCE.ADO_PIPELINE' | transloco }}</span>
              </a>
            }
            @if (tableColumn?.tag) {
              <span class="ml-4 tag pt-2 pb-2 pl-8 pr-8 fs-15" [ngClass]="data[tableColumn?.tagKey]">
                {{ data[tableColumn?.tagKey] | uppercase }}
              </span>
            }
            <!-- @if (tableColumn?.location && data?.stages?.length) {
            <span class="location-type location-tag-fixed">{{data.stages[data.stages.length - 1]?.location}}</span>
            } -->
            @if (tableColumn?.shutdown && data.shutdown) {
              <mat-icon svgIcon="timer" matTooltipClass="below my-tooltip" matTooltipPosition="below"
                [matTooltip]="('INSTANCE_DETAILS.SHUTDOWN_HOURS' | transloco | titlecase) + data.shutdown"
                class="timer-color icon-md ml-16 mt-2"></mat-icon>
            }
            @if (tableColumn?.drMode && data?.drMode) {
            <span class="dr-mode-tag" [ngClass]="data.drMode">{{ data.drMode | uppercase }}</span>
            }
            @if(pageName === 'sizingDoc' && tableColumn?.key === 'name' && data.isApplied){
              <span class="ml-8 fs-12 fw-700 sizingApplied"> Applied </span>
            }
          </div>
          </td>
        </ng-container>
      }
      @if (tableColumn.type === 'applyConfig') {
        <ng-container [matColumnDef]="tableColumn?.key">
          <th mat-header-cell *matHeaderCellDef [disabled]="!tableColumn?.sortable" class="fs-14 fw-700">
            {{ tableColumn?.name | uppercase }}
          </th>
          <td mat-cell *matCellDef="let data" class="fw-500 fs-16 flex flex-row items-center">
            @if(data?.selected) {
                @if (data?.configuration?.manifest?.config || data?.configuration?.manifest?.test || data?.configuration?.manifest?.code) {
                <span class="actions mr-12">
                  <button class="flex items-center download-btn p-8" [matMenuTriggerFor]="downloadMenu">
                    <mat-icon svgIcon="file_download" class="flex justify-end"></mat-icon>
                  </button>
                  <mat-menu #downloadMenu [xPosition]="'before'" class="context-menu-dropdown">
                    @if (data?.configuration?.manifest?.config) {
                    <button class="flex flex-row menu-button" (click)="downloadPackages(data.configuration, 'config-packs')">
                      <div class="flex flex-row justify-start items-center">
                        <mat-icon  svgIcon="file_download" class="icon-md"></mat-icon>
                        <div class="mat-body fw-500 fs-16">{{ 'INSTANCE_DETAILS.UPDATE_CONFIGURATION.CONFIGURATION_PACKAGE' | transloco | titlecase }}</div>
                      </div>
                    </button>
                    }
                    @if (data?.configuration?.manifest?.test) {
                    <button class="flex flex-row menu-button" (click)="downloadPackages(data.configuration, 'test-packs')">
                      <div class="flex flex-row justify-start items-center">
                        <mat-icon  svgIcon="file_download" class="icon-md"></mat-icon>
                        <div class="mat-body fw-500 fs-16">{{ 'INSTANCE_DETAILS.UPDATE_CONFIGURATION.TEST_PACKAGE' | transloco | titlecase }}</div>
                      </div>
                    </button>
                    }
                    @if ( data?.configuration?.manifest?.code) {
                    <button class="flex flex-row menu-button" (click)="downloadPackages(data.configuration, 'code-packs')">
                      <div class="flex flex-row justify-start items-center">
                        <mat-icon  svgIcon="file_download" class="icon-md"></mat-icon>
                        <div class="mat-body fw-500 fs-16">{{ 'INSTANCE_DETAILS.UPDATE_CONFIGURATION.CODE_PACKAGE' | transloco | titlecase }}</div>
                      </div>
                    </button>
                    }
                  </mat-menu>
                </span>
                }
                @if (data?.showApply) {
                  <span [ngClass]="{'apply-opacity' : !data.havePermission, 'disabled': data.disableApply }">
                    <button [ngClass]="{'background-color-opacity': !data.havePermission, 'disabled': data.disableApply}"
                      (click)="(data.havePermission && !data.disableApply ) ? applyConfiguration(data) : ''"
                      class="flex items-center mossgreen apply-btn">{{ 'INSTANCE_DETAILS.APPLY' | transloco }}</button>
                  </span>
                }
                @if (!data?.havePermission && data?.showApplyLock) {
                  <div class="add-lock flex red">
                    <mat-icon svgIcon="lock" class="icon-lg pl-8 lock-icon" matTooltipPosition="above"
                      matTooltipClass="tooltip-inner above pl-8 pr-8 pt-4 pb-4 fs-12"
                      [matTooltip]="'INSTANCE_DETAILS.ACCESS' | transloco"></mat-icon>
                  </div>
                }
                @if (data?.showRetry) {
                  <span [ngClass]="{'apply-opacity' : !data.havePermission, 'disabled': data.disableRetry}">
                    <button [ngClass]="{'background-color-opacity': !data.havePermission, 'disabled': data.disableRetry }"
                      (click)="(data.havePermission && !data.disableRetry) ? applyConfiguration(data) : ''"
                      class="flex items-center mossgreen apply-btn">{{ 'CONFIGURATIONS.STATE.RETRY' | transloco }}</button>
                  </span>
                }
                @if ( !data?.havePermission && data?.showRetryLock) {
                  <div class="add-lock flex red">
                    <mat-icon svgIcon="lock" class="icon-lg pl-8 lock-icon" matTooltipPosition="above"
                      matTooltipClass="tooltip-inner above pl-8 pr-8 pt-4 pb-4 fs-12"
                      [matTooltip]="'INSTANCE_DETAILS.ACCESS' | transloco"></mat-icon>
                  </div>
                }
            }
          </td>
        </ng-container>
      }
      @if (tableColumn.type === 'applyRvtConfig') {
        <ng-container [matColumnDef]="tableColumn?.key">
          <th mat-header-cell *matHeaderCellDef [disabled]="!tableColumn?.sortable" class="fs-14 fw-700">
            {{ tableColumn?.name | uppercase }}
          </th>
          <td mat-cell *matCellDef="let data" class="fw-500 fs-16 flex flex-row items-center">
            @if (data?.showActions) {
              <div>
                @if(data?.selected) {
                  <ng-container>
                    @if(data?.showExecute) {
                      <span [ngClass]="{'disabled':data.disableExecute}">
                        <button (click)="data.disableExecute ? null : executeRvt(data.configuration)"
                          class="flex items-center mossgreen mr-12 apply-btn" [ngClass]="{'disabled': data.disableExecute}">{{
                          'INSTANCE_DETAILS.EXECUTE' | transloco }}</button>
                      </span>
                    }
                    @if (data?.showRetry) {
                      <span [ngClass]="{'disabled': data.disableRetry}">
                        <button (click)="data.disableRetry ? null : executeRvt(data.configuration)"
                          class="flex items-center mossgreen mr-12 apply-btn" [ngClass]="{'disabled': data.disableRetry}">{{
                          'CONFIGURATIONS.STATE.RETRY' | transloco }}</button>
                      </span>
                    }
                  </ng-container>
                }
              </div>
            }
          </td>
        </ng-container>
      }
       @if (tableColumn.type === 'applyLocalConfig') {
      <ng-container [matColumnDef]="tableColumn?.key">
        <th mat-header-cell *matHeaderCellDef [disabled]="!tableColumn?.sortable" class="fs-14 fw-700">
          {{ tableColumn?.name | uppercase }}
        </th>
        <td mat-cell *matCellDef="let data" class="fw-500 fs-16">
          @if (data?.selected && data?.showApply && data.havePermission) {
          <span>
            <button (click)="data?.disableApply ?'' : applyLocalConfigConfirm(data)" class="mossgreen" [ngClass]="{'disabled': data.disableApply}">
              {{ 'INSTANCE_DETAILS.APPLY' | transloco }}
            </button>
          </span>
          }
        </td>
      </ng-container>
      }
      @if (tableColumn.type === 'status') {
        <ng-container [matColumnDef]="tableColumn?.key">
          <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear [disabled]="!tableColumn?.sortable" class="fs-14 fw-700">
            {{ tableColumn?.name | uppercase }}
          </th>
          <td mat-cell *matCellDef="let data" class="fw-500 fs-16 runbook-status">
            <div class="flex flex-row">
            <div class="flex items-center status pl-8 pr-8 pt-2 pb-2" [ngClass]="data[tableColumn?.key] === 'yet to start' ? 'not-started' : data[tableColumn?.key] === 'disabled' ? 'disabled-color' : packProgressStatus.includes(data[tableColumn?.key]) ? 'packProgress' : packFailedStatus.includes(data[tableColumn?.key]) ? 'packFailed' : data[tableColumn?.key]">
              <span>
                @if (!inprogressStatus.includes(data[tableColumn?.key]) && data[tableColumn?.key] !== 'yet to start') {
                  <mat-icon
                    [svgIcon]="
                      completedStatus.includes(data[tableColumn?.key])
                        ? 'check_circle_filled'
                        : failedStatus.includes(data[tableColumn?.key])
                        ? 'warning_amber'
                        : expiredStatus.includes(data[tableColumn?.key])
                        ? 'do_not_disturb_on'
                        : deletedStatus.includes(data[tableColumn?.key])
                        ? 'delete'
                        : deleteFailedStatus.includes(data[tableColumn?.key])
                        ? 'delete_forever'
                        : disabledStatus.includes(data[tableColumn?.key])
                        ? 'block'
                        : ''
                    "
                    class="icon-md p-2"
                    [ngClass]="data[tableColumn?.key]"
                  ></mat-icon>
                } @else if(inprogressStatus.includes(data[tableColumn?.key])){
                  <mat-spinner *ngIf="inprogressStatus.includes(data[tableColumn?.key])" diameter="16" class="mr-8 progress-color" mode="indeterminate"></mat-spinner>
                } @else {
                  <mat-icon
                    svgIcon="circle" class="icon-md p-2 mr-4">
                  </mat-icon>
                }
              </span>
              <span>
                {{
                  (((data[tableColumn?.key] === 'completed' && pageName !=='environmentBaseImage') && page !== 'schedule' && pageName !== 'environmentJobs' && pageName !== 'environmentDatabases') || (data[tableColumn?.key] === 'added' && pageName === 'sftp'))
                    ? 'Created'
                    : (data[tableColumn?.key] === 'adding' && pageName === 'sftp')
                    ? 'In Progress'
                    : data[tableColumn?.key] === 'completed' && !data[tableColumn?.statusKey]  && pageName !== 'environmentDatabases'
                    ? 'Success'
                    : data[tableColumn?.key] === 'delete_failed'
                    ? 'Delete Failed'
                    : data[tableColumn?.key] === 'config_failed'
                    ? 'Config Failed'
                    : data[tableColumn?.key] === '--N/A--'
                    ? (data[tableColumn?.key])
                    : (data[tableColumn?.key] | titlecase)
                }}
              </span>
              <mat-icon *ngIf="(data?.status === 'failed' || data?.status === 'config_failed' || data?.status === 'update_failed' || data?.status === 'delete_failed') && hasErrors(data) && !(pageName === 'environmentBaseImage')" svgIcon="message_icon" class="icon-md cursor-pointer error-icon" (click)="viewErrors(data)"></mat-icon>
            </div>
            <!-- <div class="flex pl-24 pr-12">
              @if (pageName === 'environmentBaseImage' && data.status === 'failed' && data?.name?.toLowerCase()?.startsWith('latest')) {
                 <button class="cursor-pointer retry-color flex justify-center items-center mat-subtitle-2 fw-700 pl-12 pr-12" [ngClass]="{'disabled': instanceInprogress}" (click)="retryBaseImage.emit(data)">
                  {{ 'CONFIGURATIONS.STATE.RETRY' | transloco }}
                </button> 
              }
            </div> -->
             @if (pageName === 'activity' && inprogressStatus.includes(data[tableColumn?.key]) && activityProgressService.getTimeRemaining(data?.startTime, data?.expectedDurationMs, currentTime); as timeLeft) {
                  <span class="fs-16 fw-400 ml-12 time-remaining">
                    {{ timeLeft }}
                  </span>
                  }
            </div>
          </td>
        </ng-container>
      }

      @if (tableColumn.type === 'userIcon') {
        <ng-container [matColumnDef]="tableColumn?.key">
          <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear [disabled]="!tableColumn?.sortable" class="fs-14 fw-700">
            {{ tableColumn?.name | uppercase }}
          </th>
          <td mat-cell *matCellDef="let data" class="fw-500 fs-16 user-icon">
          @if(data[tableColumn?.key]){
            <img
              matTooltipClass="tooltip-inner left account-db"
              [matTooltip]="data[tableColumn?.key]"
              src="assets/images/account_circle.svg"
              alt="User"
              matTooltipPosition="left"
            />
          } @else {
            <div class="hyphen">-</div>
          }
          </td>
        </ng-container>
      }

        @if (tableColumn.type === 'user') {
        <ng-container [matColumnDef]="tableColumn?.key">
          <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear [disabled]="!tableColumn?.sortable" class="fs-14 fw-700">
            {{ tableColumn?.name | uppercase }}
          </th>
          <td mat-cell *matCellDef="let data" class="fw-500 fs-16 user-icon">
          @if(data?.modifiedBy || data?.createdBy){
            <img
              matTooltipClass="tooltip-inner left account-db"
              [matTooltip]="data?.modifiedBy ? data?.modifiedBy : data?.createdBy"
              src="assets/images/account_circle.svg"
              alt="User"
              matTooltipPosition="left"
            />
          } @else {
            <div class="hyphen">-</div>
          }
          </td>
        </ng-container>
      }

      @if (tableColumn.type === 'date') {
        <ng-container [matColumnDef]="tableColumn?.key">
          <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear [disabled]="!tableColumn?.sortable" class="fs-14 fw-700">
            {{ tableColumn?.name | uppercase }}
          </th>
          <td mat-cell *matCellDef="let data" class="fw-400 fs-16">
            {{ data[tableColumn?.key] ? (data[tableColumn?.key] | date:'dd MMM yyyy HH:mm:ss' : 'UTC') : '-' }}
          </td>
        </ng-container>
      }
      @if (tableColumn.type === 'dateWithoutTime') {
        <ng-container [matColumnDef]="tableColumn?.key">
          <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear [disabled]="!tableColumn?.sortable" class="w-1/8 text-left py-2 font-medium"> {{ tableColumn?.name | uppercase }} </th>
          <td mat-cell *matCellDef="let data" class="w-1/8 text-left py-2 expiry-date">
            {{ (data[tableColumn?.key] | date: 'dd MMM yyyy') }}</td>
        </ng-container>
      }
      @if (tableColumn.type === 'timeline') {
        <ng-container matColumnDef="timeline" class="timeline-col">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row;">
            <div class="timeline-wrapper">
            @if (getRowIndex(row) > 0) {
              <div class ="line" [ngClass]="failedStatus.includes(row.status) ? 'line-dotted' : (completedStatus.includes(row.status) && inprogressStatus.includes(pageDataSource?.data[getRowIndex(row)-1].status)) ? 'line-solid'
                : (completedStatus.includes(row.status) && completedStatus.includes(pageDataSource?.data[getRowIndex(row)-1].status)) ? 'line-solid' : (inprogressStatus.includes(pageDataSource?.data[getRowIndex(row)-1].status) && completedStatus.includes(row.status))
                ? 'line-solid' : (inprogressStatus.includes(row.status) && (completedStatus.includes(pageDataSource?.data[getRowIndex(row)-1].status) || inprogressStatus.includes(pageDataSource?.data[getRowIndex(row)-1].status))) ? 'line-solid'
                : 'line-dotted'">
              </div>
            }
              <div class="dot" [ngClass]="{'completed': completedStatus.includes(row.status),'failed': failedStatus.includes(row.status),'started-inprogress': inprogressStatus.includes(row.status), 'not-started': row.status === 'yet to start'}">
              </div>
            @if (getRowIndex(row) < pageDataSource?.data.length - 1) {
              <div class ="line" [ngClass]="{'line-solid-bottom': completedStatus.includes(pageDataSource?.data[getRowIndex(row) + 1].status) || (pageDataSource?.data[getRowIndex(row) + 1].status) === 'started',
              'line-dotted-bottom': !completedStatus.includes(pageDataSource?.data[getRowIndex(row) + 1].status) && (pageDataSource?.data[getRowIndex(row) + 1].status) !== 'started'}">
              </div>
            }
            </div>
          </td>
        </ng-container>

      }
      @if (tableColumn.type === 'duration') {
        <ng-container [matColumnDef]="tableColumn?.key">
          <th mat-header-cell mat-sort-header disableClear [disabled]="!tableColumn?.sortable" *matHeaderCellDef class="fs-14 fw-700">
            {{ tableColumn?.name | uppercase }}
          </th>

          <td mat-cell *matCellDef="let data" class="fw-400 fs-16">
            {{pageName === 'releasePackView' ? (data[tableColumn?.startKey] | duration : data[tableColumn?.endKey]) : (data[tableColumn?.startKey] | timeDuration : data[tableColumn?.endKey]) ? (data[tableColumn?.startKey] | timeDuration : data[tableColumn?.endKey]) : '-'}}
          </td>
        </ng-container>
      }
       @if (tableColumn.type === 'count') {
        <ng-container [matColumnDef]="tableColumn?.key">
          <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700">
            {{ tableColumn?.name | uppercase }}
          </th>

          <td mat-cell *matCellDef="let data" class="fw-400 fs-16">
            @if (tableColumn.key === 'successCount') {
              <span class="pt-2 pr-8 pb-2 pl-8 success">{{countSuccess(data)}}</span>
            } @else if (tableColumn.key === 'failureCount') {
              <span class="pt-2 pr-8 pb-2 pl-8 failed">{{countFailure(data)}}</span>
            }
          </td>
        </ng-container>
      }
     @if (tableColumn.type === 'download') {
  <ng-container [matColumnDef]="tableColumn?.key">
    <th mat-header-cell *matHeaderCellDef></th>

    <td mat-cell *matCellDef="let data">
      {{data.name}}
      <ng-container *ngIf="data?.reportFile; else noReport">
        <mat-icon
          svgIcon="file_download"
          class="cursor-pointer"
          [ngClass]="{'disabled': data?.status === 'inprogress'}"
          (click)="downloadCobReport(data)">
        </mat-icon>
      </ng-container>

      <ng-template #noReport>
        <span class="pl-30"></span>
      </ng-template>
    </td>

  </ng-container>
}
      @if (tableColumn.type === 'result') {
        <ng-container [matColumnDef]="tableColumn?.key">
       <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700">
            {{ tableColumn?.name | uppercase }}
       </th>
      <td mat-cell *matCellDef="let data" [ngClass]="{'selected': data.arrowClick}" class="fw-400 fs-16">
        @if (data[tableColumn?.key]) {
        <span>
          <mat-icon
            svgIcon="file_download"
            class="cursor-pointer"
            [ngClass]="{'disabled': data?.status === 'inprogress'}"
            (click)="downloadResult(data)">
          </mat-icon>
          <mat-icon
            svgIcon="visibility"
            class="cursor-pointer ml-16"
            [ngClass]="{'disabled': data?.status === 'inprogress'}"
            (click)="viewTestResults(data, 'EFTestResults')">
          </mat-icon>
        </span>
        } @else {
          {{data[tableColumn?.key]}}
          <span class="pl-30">-</span>
        }
      </td>
  </ng-container>
}

      @if (tableColumn.type === 'button') {
        <ng-container [matColumnDef]="tableColumn?.key">
          <th mat-header-cell *matHeaderCellDef class="button-column text-left py-2 font-medium"> {{ tableColumn?.name | uppercase }} </th>
          <td mat-cell *matCellDef="let data" class="button-column text-left py-2">
            <ng-container *ngIf="pageName === 'runbook'">
              <button *ngIf="(data?.status === 'failed' || data?.status === 'config_failed') && isCreateRunbookAllowed" type="button" class="cursor-pointer accent flex justify-center items-center mat-subtitle-2 fw-700 add-btn pl-12 pr-12" [ngClass]="{'disabled': isRunbookDeploying || instanceInprogress}" mat-button (click)="(isRunbookDeploying || instanceInprogress) ? '' : redeployClick(data)">
                {{'RUNBOOK.REDEPLOY' | transloco }}
              </button>
            </ng-container>
            @if (pageName === 'sftp') {
              <button *ngIf="permissionsMap[PermissionKeys.INSTANCE_SFTP_CONFIG_DATAZONE_NONPII] || permissionsMap[PermissionKeys.INSTANCE_SFTP_CONFIG_DATAZONE_PII] || permissionsMap[PermissionKeys.INSTANCE_SFTP_CONFIG_DATAZONE_LIVE]" type="button" [ngClass]="{'disabled': (data?.status !== 'added' && data?.status !== 'updated')}" class="cursor-pointer flex justify-center items-center mat-subtitle-2 fw-600 ssh-btn" mat-button (click)="openSshKeyForm(data)">
                <mat-icon svgIcon="add" class="icon-md-2"></mat-icon>
                {{'INSTANCE_DETAILS.SSH_KEY' | transloco }}
              </button>
            }
          </td>
        </ng-container>
      }

      @if (tableColumn.type === 'dbName') {
        <ng-container [matColumnDef]="tableColumn?.key">
          <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear [disabled]="!tableColumn?.sortable" class="fs-14 fw-700">
            {{ tableColumn?.name | uppercase }}
          </th>
          <td mat-cell *matCellDef="let data" class="fw-500 fs-16">
            <span class="db-name">
            <span class="text-ellipsis fw-400 fs-16" [ngClass]="{'clickable': data[tableColumn?.keyLink] || tableColumn?.keyLink === 'navigation' || tableColumn?.keyLink === 'popup', 'max-w-[300px]':(tableColumn?.key === 'name' && data[tableColumn?.key]?.length > 32)}" (click)="tableColumn?.keyLink === 'navigation' ? popupOpen(data) : this.pageName === runbook ? runbookPopup(data) : '' " matTooltipPosition="above" [matTooltip]="tableColumn?.key === 'name' && data[tableColumn?.key]?.length > 32 ? data[tableColumn?.key] : ''" [matTooltipClass]="tableColumn?.key === 'name' ? 'tooltip-inner above runbook-name' : 'tooltip-inner left account-db'">
              {{ data[tableColumn?.key]?.length > 32 ? ((data[tableColumn?.key] | titlecase) | slice:0:32) + '…' : (data[tableColumn?.key] | titlecase) }}
            </span>
            @if (tableColumn?.tag) {
              <span class="ml-12 tag pt-2 pb-2 pl-8 pr-8 fs-15" [ngClass]="data[tableColumn?.tagKey]">
                {{ data[tableColumn?.tagKey] | uppercase }}
              </span>
            }
             <mat-icon *ngIf="(data?.typeTag === 'PostgreSQL' && data?.to?.serverName) || (data?.to?.fileName && data?.backupType === 'archive') || ( data?.to?.databaseName && data?.backupType === 'snapshot')" svgIcon="info" class="cursor-pointer icon-sm ml-6 mt-2" matTooltipClass="above" matTooltipPosition="above" [matTooltip]="data?.typeTag === 'PostgreSQL' ? data?.to?.serverName : data?.backupType === 'snapshot' ? data?.to?.databaseName : data?.backupType === 'archive' ? data?.to?.fileName : '-'"></mat-icon>
              <span *ngIf="( data?.backupType === 'archive') || ( data?.backupType === 'snapshot')" class="pl-8 pr-8 backup-tag fs-10 fw-700 ml-8 mr-12" [ngClass]="{'archive': data?.backupType === 'archive', 'snapshot': data?.backupType === 'snapshot'}">{{data?.backupType | uppercase }}</span>
              <span *ngIf="((data?.backupType === 'archive') || (data?.backupType === 'snapshot')) && data?.typeTag" class="pl-8 pr-8 backup-tag fs-10 fw-700 ml-8 mr-12" [ngClass]="{'archive': data?.typeTag === 'MSSQL', 'snapshot': data?.typeTag === 'PostgreSQL'}">{{data?.typeTag}}</span>
              </span>
            </td>
        </ng-container>
      }

      @if (tableColumn.type === 'dbAction') {
        <ng-container [matColumnDef]="tableColumn?.key">
          <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700">
            {{ tableColumn?.name | uppercase }}
          </th>
          <td mat-cell *matCellDef="let data" class="fw-400 fs-16 text-center">
            @if(data.backupType === 'snapshot' ){
            <button class="pl-6 pr-6 runbook-menu" [matMenuTriggerFor]="runbookMenu">
              <mat-icon svgIcon="more_vert"></mat-icon>
            </button>
             <mat-menu #runbookMenu [xPosition]="'before'" class="context-menu-dropdown arrow-menu">
              <button class="flex flex-row menu-button" [disabled]="(data?.status !== 'completed' && data?.status !== 'extended') || instanceInprogress" (click)="((data?.status !== 'completed' && data?.status !== 'extended') || instanceInprogress) ? '' : openDeleteForm(data)">
                <div class="flex flex-row justify-start items-center">
                  <mat-icon svgIcon="delete" class="icon-md delete"></mat-icon>
                  <div class="mat-body fw-500 fs-16"  [ngClass]="{'delete': (data?.status === 'completed' || data?.status === 'extended') && !instanceInprogress}">{{ 'BUTTONS.DELETE' | transloco }}</div>
                </div>
              </button>

              <button class="flex flex-row menu-button" [disabled]="(data?.status !== 'completed' && data?.status !== 'extended') || instanceInprogress" (click)="((data?.status !== 'completed' && data?.status !== 'extended') || instanceInprogress) ? '' : extendBackup(data)">
                <div class="flex flex-row justify-start items-center">
                  <mat-icon svgIcon="more_time" class="icon-md"></mat-icon>
                  <div class="mat-body fw-500 fs-16">{{ 'INSTANCE_DETAILS.EXTEND_BACKUP' | transloco }}</div>
                </div>
              </button>
            </mat-menu>
            }
          </td>
        </ng-container>
      }
      @if (tableColumn.type === 'action') {
        <ng-container [matColumnDef]="tableColumn?.key">
          <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 action-column">
            {{ tableColumn?.name | uppercase }}
          </th>
          <td mat-cell *matCellDef="let data" class="fw-400 fs-16 text-center">
            <button class="pl-6 pr-6 runbook-menu" [matMenuTriggerFor]="runbookMenu" (click)="checkRunbookDeploying()">
              <mat-icon svgIcon="more_vert"></mat-icon>
            </button>
             <mat-menu #runbookMenu [xPosition]="'before'" class="context-menu-dropdown">
              <div class="flex flex-col">
              @if (isEditRunbookAllowed){
              <button class="flex flex-row menu-button" [disabled]="(data?.status !== 'deployed' && data?.status !== 'configured' && data?.status !== 'updated') || isRunbookDeploying || instanceInprogress" (click)="((data?.status !== 'deployed' && data?.status !== 'configured' && data?.status !== 'updated') || isRunbookDeploying || instanceInprogress) ? '' : editRunbook(data)">
                <div class="flex flex-row justify-start items-center">
                  <mat-icon svgIcon="edit"  class="icon-md"></mat-icon>
                  <div class="mat-body fw-500 fs-16">{{ 'RUNBOOK.EDIT_RUNBOOK' | transloco }}</div>
                </div>
              </button>
            }
              <button class="flex flex-row menu-button" [disabled]="(data?.status !== 'deployed' && data?.status !== 'configured' && data?.status !== 'updated') || isRunbookDeploying || instanceInprogress" (click)="((data?.status !== 'deployed' && data?.status !== 'configured' && data?.status !== 'updated') || isRunbookDeploying || instanceInprogress) ? '' : createSchedule(data)">
                <div class="flex flex-row justify-start items-center">
                  <mat-icon svgIcon="schedule" class="icon-md delete"></mat-icon>
                  <div class="mat-body fw-500 fs-16">{{ 'RUNBOOK.CREATE_SCHEDULE' | transloco }}</div>
                </div>
              </button>
               @if (isEditRunbookAllowed){
              <button class="flex flex-row menu-button version-update-btn" [disabled]="(data?.status !== 'deployed' && data?.status !== 'configured' && data?.status !== 'updated') || isRunbookDeploying || instanceInprogress" (click)="((data?.status !== 'deployed' && data?.status !== 'configured' && data?.status !== 'updated') || isRunbookDeploying || instanceInprogress) ? '' : upgardeRunbookVersion(data)">
                <div class="flex flex-row justify-start items-center">
                  <mat-icon svgIcon="rule_settings" class="icon-md"></mat-icon>
                  <div class="mat-body fw-500 fs-16">{{ 'RUNBOOK.VERSION_UPDATE' | transloco }}</div>
                </div>
              </button>
              }
              @if (isDeleteRunbookAllowed) {
              <mat-divider></mat-divider>
              <button class="flex flex-row menu-delete" [disabled]="(data?.status !== 'deployed' && data?.status !== 'configured' && data?.status !== 'failed' && data?.status !== 'config_failed' && data?.status !== 'delete_failed' && data?.status !== 'updated') || isRunbookDeploying || instanceInprogress"
                (click)="((data?.status !== 'deployed' && data?.status !== 'configured' && data?.status !== 'failed' && data?.status !== 'config_failed' && data?.status !== 'delete_failed' && data?.status !== 'updated') || isRunbookDeploying || instanceInprogress) ? '' : deleteRunbook(data)">
                  <div class="flex flex-row justify-start items-center color-red">
                    <mat-icon svgIcon="delete" class="icon-md color-red"></mat-icon>
                    <div class="mat-body fw-500 fs-16">{{ 'BUTTONS.DELETE' | transloco }}</div>
                  </div>
              </button>
              }
              </div>
            </mat-menu>
          </td>
        </ng-container>
      }
      @if (tableColumn.type === 'scheduleAction') {
        <ng-container [matColumnDef]="tableColumn?.key">
          <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 action-column">
            {{ tableColumn?.name | uppercase }}
          </th>
          <td mat-cell *matCellDef="let data" class="fw-400 fs-16 text-center">
            <button class="pl-6 pr-6 runbook-menu" [matMenuTriggerFor]="scheduleMenu">
              <mat-icon svgIcon="more_vert"></mat-icon>
            </button>
             <mat-menu #scheduleMenu [xPosition]="'before'" class="context-menu-dropdown">
              <div class="flex flex-col">
              @if(isScheduleAllowed) {
              <button class="flex flex-row menu-button"
              [disabled]="(data?.status !== 'created' && data?.status !== 'updated' && data?.status !== 'failed' && data?.status !== 'update_failed' && data?.status !== 'enabled') || isRunbookDeploying || instanceInprogress" (click)="((data?.status !== 'created' && data?.status !== 'updated' && data?.status !== 'failed' && data?.status !== 'update_failed' && data?.status !== 'enabled') || isRunbookDeploying || instanceInprogress) ? '' : editSchedule(data)">
                <div class="flex flex-row justify-start items-center">
                  <mat-icon svgIcon="edit"  class="icon-md"></mat-icon>
                  <div class="mat-body fw-500 fs-16">{{ 'SCHEDULE.EDIT_SCHEDULE' | transloco }}</div>
                </div>
              </button>
              }
              <button (click)="(data?.status !== 'created' && data?.status !== 'updated' && data?.status !== 'enabled' && data?.status !== 'disabled') ? '' : viewJobs(data)" [ngClass]="{'disabled': (data?.status !== 'created' && data?.status !== 'updated' && data?.status !== 'enabled' && data?.status !== 'disabled')}">
                <div class="flex flex-row justify-start items-center">
                  <mat-icon svgIcon="work_outline"  class="icon-md"></mat-icon>
                  <div class="mat-body fw-500 fs-16">{{ 'JOBS.VIEW_JOBS' | transloco }}</div>
                </div>
              </button>
              @if(isDeleteScheduleAllowed){
              <mat-divider></mat-divider>
              <button class="flex flex-row menu-delete" [disabled]="(data?.status !== 'created' && data?.status !== 'updated' && data?.status !== 'failed' && data?.status !== 'update_failed' &&  data?.status !== 'delete_failed') || isRunbookDeploying || instanceInprogress" (click)="((data?.status !== 'created' && data?.status !== 'updated' && data?.status !== 'failed' && data?.status !== 'update_failed' &&  data?.status !== 'delete_failed') || isRunbookDeploying || instanceInprogress) ? '' : deleteSchedule(data)">
                <div class="flex flex-row justify-start items-center color-red">
                  <mat-icon svgIcon="delete"  class="icon-md color-red"></mat-icon>
                  <div class="mat-body fw-500 fs-16">{{ 'BUTTONS.DELETE' | transloco }}</div>
                </div>
              </button>
              }
              </div>
            </mat-menu>
          </td>
        </ng-container>
      }
       @if (tableColumn.type === 'jobAction') {
        <ng-container [matColumnDef]="tableColumn?.key">
          <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700">
            {{ tableColumn?.name | uppercase }}
          </th>
          <td mat-cell *matCellDef="let data" class="fw-400 fs-16 text-center">
            <button class="pl-6 pr-6 runbook-menu" (click)="checkRunbookDeploying()">
              <mat-icon svgIcon="more_vert"></mat-icon>
            </button>
          </td>
        </ng-container>
      }
        @if (tableColumn.type === 'sizingApply') {
        <ng-container [matColumnDef]="tableColumn?.key">
          <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700">
            {{ tableColumn?.name | uppercase }}
          </th>
          <td mat-cell *matCellDef="let data" class="flex justify-center fs-16 mt-6 border-bottom">
            @if (data?.selected && !data?.isApplied && !data?.isLowerVersion && data?.isInstanceDeployed && isEditSizingAllowed) {
              <button class="flex items-center mossgreen apply-btn" (click)="applySizing(data)">
                {{ 'INSTANCE_DETAILS.APPLY' | transloco }}
              </button>
            }
          </td>
        </ng-container>
      }
      @if (tableColumn.type === 'sizingDocAction') {
        <ng-container [matColumnDef]="tableColumn?.key">
          <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 action-column">
            {{ (isEditSizingAllowed || isDeleteSizingAllowed) ? (tableColumn?.name | uppercase) : '' }}
          </th>
          <td mat-cell *matCellDef="let data" class="fw-400 fs-16 text-center">
            @if(isEditSizingAllowed || isDeleteSizingAllowed) {
            <button class="pl-6 pr-6 ssh-menu" [matMenuTriggerFor]="sizingMenu" (click)="openSizingMenu()">
              <mat-icon svgIcon="more_vert"></mat-icon>
            </button>
            }
            <mat-menu #sizingMenu [xPosition]="'before'" class="context-menu-dropdown">
                <div class="flex flex-col">
                  @if(isDeleteSizingAllowed) {
                  <button class="menu-button delete" (click)="(!instanceInprogress  && !data.isApplied) ? deleteSizing(data) : null" [ngClass]="[data.isApplied || instanceInprogress ? 'disabled-btn cursor-default' : 'cursor-pointer']">
                    <div class="flex flex-row justify-start items-center">
                      <mat-icon svgIcon="delete" class="icon-md delete sftp-icon"></mat-icon>
                      <div class="mat-body fw-500 fs-16 delete">{{ 'BUTTONS.DELETE' | transloco }}</div>
                    </div>
                  </button>
                }
                </div>
                <div class="flex flex-col">
                  @if(isEditSizingAllowed) {
                  <button class="menu-button delete" (click)="(!instanceInprogress  && !data.isApplied) ? editSizing(data) : null" [ngClass]="[data.isApplied || instanceInprogress ? 'disabled-btn cursor-default' : 'cursor-pointer']">
                    <div class="flex flex-row justify-start items-center">
                      <mat-icon svgIcon="edit" class="icon-md sftp-icon"></mat-icon>
                      <div class="mat-body fw-500 fs-16">{{ 'BUTTONS.EDIT' | transloco }}</div>
                    </div>
                  </button>
                }
                </div>
            </mat-menu>
          </td>
        </ng-container>
      }
      @if (tableColumn.type === 'settings') {
        <ng-container [matColumnDef]="tableColumn?.key">
          <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 settings">
            <mat-icon svgIcon="settings_filled" class="icon-md" [ngClass]="{'ml-10': tableColumn.key === 'sftpSettings' || tableColumn.key === 'sftpKeySettings'}" (click)="columnSettings()"></mat-icon>
          </th>
          <td mat-cell *matCellDef="let data">
            @if (tableColumn.key === 'cloudInventorySettings') {
              <mat-icon svgIcon="description" class="icon-lg ml-8 cursor-pointer" (click)="copyInventoryDetails(data)"> </mat-icon>
            }
            @if (tableColumn.key === 'sftpSettings') {
              <button class="pl-6 pr-6 ssh-menu"
                      [matMenuTriggerFor]="sftpMenu" (click)="openMenu()">
                <mat-icon svgIcon="more_vert"></mat-icon>
              </button>
              <mat-menu #sftpMenu [xPosition]="'before'" class="context-menu-dropdown">
                <div class="flex flex-col">
                  <button class="menu-button" (click)="sftpEncKeyRotation ? editRoute(data) : null"
                  [ngClass]="[(!sftpEncKeyRotation || data.status === 'adding' || data.status === 'removing'
                  || data.status === 'removed') ? 'disabled-btn cursor-default' : 'cursor-pointer']"
                  [disabled]="!sftpEncKeyRotation || data.status === 'adding' || data.status === 'removing' || data.status === 'removed'">
                    <div class="flex flex-row justify-start items-center">
                      <mat-icon svgIcon="edit" class="icon-md sftp-icon"></mat-icon>
                      <div class="mat-body fw-500 fs-16">{{'SOLUTIONS.EDIT' | transloco }}</div>
                    </div>
                  </button>
                  <button class="menu-button delete" (click)="deleteRoute(data)" [ngClass]="[(data.status === 'adding' || data.status === 'removing' || data.status === 'removed') ? 'disabled-btn cursor-default' : 'cursor-pointer']">
                    <div class="flex flex-row justify-start items-center">
                      <mat-icon svgIcon="delete" class="icon-md delete sftp-icon"></mat-icon>
                      <div class="mat-body fw-500 fs-16 delete">{{ 'BUTTONS.DELETE' | transloco }}</div>
                    </div>
                  </button>
                </div>
              </mat-menu>
            }
            @if (tableColumn.key === 'sftpKeySettings') {
              <button class="pl-6 pr-6 ssh-menu"
                      [matMenuTriggerFor]="sftpMenu" (click)="openMenu()">
                <mat-icon svgIcon="more_vert"></mat-icon>
              </button>
              <mat-menu #sftpMenu [xPosition]="'before'" class="context-menu-dropdown">
                <div class="flex flex-col">
                  <button class="menu-button" (click)="editKeyRoute(data)">
                    <div class="flex flex-row justify-start items-center">
                      <mat-icon svgIcon="edit" class="icon-md sftp-icon"></mat-icon>
                      <div class="mat-body-1 fw-400">{{'SOLUTIONS.EDIT' | transloco }}</div>
                    </div>
                  </button>
                </div>
              </mat-menu>
            }
          </td>
        </ng-container>
      }

    }

    <ng-container hidden matColumnDef="arrow">
      <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"></th>
      <td mat-cell *matCellDef="let data" class="arrow" [ngClass]="{'selected': data.arrowClick}" class="route-id cell-data fw-400 fs-16"></td>
    </ng-container>
    <ng-container matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let element"  [attr.colspan]="page === 'sftp' ? 9 : 11" [ngClass]="{'inner-table': element.routeId === expandedElement?.routeId}" class="inner-table">
        @if (page === 'sftp' && element.routeId === expandedElement?.routeId) {
          <div class="flex flex-col mt-24 ml-32 mr-24 mb-8 expand-details" [@detailExpand]="element.routeId === expandedElement?.routeId ? 'expanded' : 'collapsed'">
            <div class="expanded-row">
              @if (expandedElement?.destinationType === 'artifactory') {
                <div class="route-metrics pt-8 pb-8">
                  <div class="expand-header pb-8">{{'ROUTE_FORM.CI_PROVIDER' | transloco}}</div>
                  <div class="overview-values expand-value" [title]="expandedElement?.ciTriggerConfig?.ciProvider ? expandedElement?.ciTriggerConfig?.ciProvider : '-'">{{expandedElement?.ciTriggerConfig?.ciProvider ? expandedElement?.ciTriggerConfig?.ciProvider : '-'}}</div>
                </div>
                <div class="route-metrics pt-8 pb-8">
                  <div class="expand-header pb-8 flex">{{'ROUTE_FORM.PROJECT_ID' | transloco}}
                    <span> <mat-icon svgIcon="content_copy" class="icon-sm ml-8 cursor-pointer icon" [cdkCopyToClipboard]="expandedElement?.ciTriggerConfig?.projectName" (click)="onCopy('Project Id')"></mat-icon></span>
                  </div>
                  <div class="overview-values expand-value" [title]="expandedElement?.ciTriggerConfig?.projectName ? expandedElement?.ciTriggerConfig?.projectName : '-'">{{expandedElement?.ciTriggerConfig?.projectName ? expandedElement?.ciTriggerConfig?.projectName : '-'}}</div>
                </div>
                <div class="route-metrics pt-8 pb-8">
                  <div class="expand-header pb-8">{{'ROUTE_FORM.BRANCH' | transloco}}</div>
                  <div class="overview-values expand-value" [title]="expandedElement?.ciTriggerConfig?.branch ? expandedElement?.ciTriggerConfig?.branch : '-'">{{expandedElement?.ciTriggerConfig?.branch ? expandedElement?.ciTriggerConfig?.branch : '-'}}</div>
                </div>
                <div class="route-metrics pt-8 pb-8">
                  <div class="expand-header pb-8">{{'ROUTE_FORM.CI_TRIGGER_ENABLED' | transloco}}</div>
                  <div class="overview-values expand-value" [title]="expandedElement?.ciTriggerEnabled ? expandedElement?.ciTriggerEnabled : '-'">{{expandedElement?.ciTriggerEnabled ? expandedElement?.ciTriggerEnabled : '-'}}</div>
                </div>
                <div class="route-metrics pt-8 pb-8 pr-20">
                  <div class="expand-header pb-8">{{'INSTANCE_DETAILS.COMPONENT_FILE_PATH' | transloco}}</div>
                  <div class="overview-values expand-value status-color" [title]="expandedElement?.componentFilePath ? expandedElement?.componentFilePath :'-'">{{expandedElement?.componentFilePath ? expandedElement?.componentFilePath :'-'}}</div>
                </div>
              } @else {
              <div class="route-metrics pt-8 pb-8 pr-20">
                <div class="expand-header pb-8">{{'INSTANCE_DETAILS.HOME_PATH' | transloco}}</div>
                <div class="overview-values expand-value" [title]="expandedElement?.homePath ? expandedElement?.homePath : '-'">{{expandedElement?.homePath ? expandedElement?.homePath : '-'}}</div>
              </div>
              <div class="metrics-url pt-8 pb-8 pr-20">
                <div class="expand-header pb-8 flex">{{'INSTANCE_DETAILS.COMPONENT_STORAGE' | transloco}}<span><mat-icon svgIcon="content_copy" class="icon-sm ml-8 cursor-pointer icon"
                  [cdkCopyToClipboard]="expandedElement?.componentStorage" (click)="onCopy('Component Storage')"></mat-icon></span></div>
                <div class="overview-values expand-value">
                  <a href="javascript:void(0);" [title]="expandedElement?.componentStorage ? expandedElement?.componentStorage : '-'" (click)="openComponentStorageUrl(expandedElement?.componentStorage)">{{expandedElement?.componentStorage ? expandedElement?.componentStorage : '-'}}</a>
                </div>
              </div>
              <div class="route-metrics pt-8 pb-8">
                <div class="expand-header pb-8">{{'INSTANCE_DETAILS.COMPONENT_FILE_SHARE' | transloco}}</div>
                <div class="overview-values expand-value" [title]="expandedElement?.componentFileShare ? expandedElement?.componentFileShare : '-'">{{expandedElement?.componentFileShare ? expandedElement?.componentFileShare : '-'}}</div>
              </div>
              <div [ngClass]="{'disabled-btn': !expandedElement?.encKeyName}" class="flex flex-col route-metrics pt-8 pb-8">
                <div class="expand-header pb-8">{{'INSTANCE_DETAILS.KEY_NAME' | transloco}}</div>
                <div class="flex flex-col key-name basis-full pb-22">
                  <div class="flex flex-row"><span class="expand-value key-value">{{ expandedElement?.encKeyName  || '-' }}</span></div>
                  <div class="flex flex-row"><span *ngIf="expandedElement?.encKeyName" class="fs-12 fw-400" [ngClass]="!getExpiryStatus(expandedElement?.encKeyExpirationDate) ? 'expires-badge':'expiry-badge'">{{(!getExpiryStatus(expandedElement?.encKeyExpirationDate) ? 'INSTANCE_DETAILS.EXPIRES_ON':'INSTANCE_DETAILS.EXPIRED_ON') | transloco}} {{ expandedElement?.encKeyExpirationDate }}</span></div>
                </div>
              </div>
              <div class="route-metrics pt-8 pb-8 pr-20">
                <div class="expand-header pb-8">{{'INSTANCE_DETAILS.COMPONENT_FILE_PATH' | transloco}}</div>
                <div class="overview-values expand-value status-color" [title]="expandedElement?.componentFilePath ? expandedElement?.componentFilePath :'-'">{{expandedElement?.componentFilePath ? expandedElement?.componentFilePath :'-'}}</div>
              </div>
              <div class="metrics-url pt-8 pb-8 pr-20">
                <div class="expand-header pb-8 flex items-center">{{'INSTANCE_DETAILS.ENDPOINT' | transloco}}<span><mat-icon svgIcon="content_copy" class="icon-sm ml-8 cursor-pointer icon"
                  [cdkCopyToClipboard]="expandedElement?.overview?.endpoint" (click)="onCopy('Endpoint')"></mat-icon></span></div>
                <div class="overview-values expand-value" [title]="expandedElement?.overview?.endpoint ? expandedElement?.overview?.endpoint : '-'">{{expandedElement?.overview?.endpoint ? expandedElement?.overview?.endpoint : '-'}}</div>
              </div>
              <div class="route-metrics pt-8 pb-8">
                <div class="expand-header pb-8 flex items-center">{{'INSTANCE_DETAILS.USERNAME' | transloco}}<span><mat-icon svgIcon="content_copy" class="icon-sm ml-8 cursor-pointer icon"
                  [cdkCopyToClipboard]="expandedElement?.overview?.username" (click)="onCopy('User Name')"></mat-icon></span>
                  <span *ngIf="expandedElement?.sshPublicKeys?.length > 0" class="mat-body fs-12 fw-500 key-added cursor-pointer pl-16" (click)="viewSshKeys(expandedElement)">{{expandedElement?.sshPublicKeys?.length}}{{'INSTANCE_DETAILS.SSH_KEY_ADDED' | transloco}}</span>
                </div>
                <div class="overview-values expand-value" [title]="expandedElement?.overview?.username ? expandedElement?.overview?.username : '-'">{{expandedElement?.overview?.username ? expandedElement?.overview?.username : '-'}}</div>
              </div>
              }
            </div>
          </div>
        } @else if (page === 'activity' && element.contextId === expandedElement?.contextId) {
          <div class="example-element-detail flex-col"
            [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'">
            <ng-container>
              @if (element.innerLoading) {
                <div class="loader-section">
                    <div class="instances-group loader-header flex flex-col p-16">
                      <div class="flex flex-row">
                        @for (tableColumn of innerTableColumns; track tableColumn?.key) {
                          <div class="loader-style">
                            <ngx-skeleton-loader class="flex loader-line mr-60" count="1" appearance="line"></ngx-skeleton-loader>
                          </div>
                        }
                      </div>
                    </div>
                    @for (item of [1, 2, 3]; track $index) {
                <div class="w-100-percent">
                  <div class="instances-group flex flex-col p-16">
                    <div class="flex flex-row">
                      @for (tableColumn of innerTableColumns; track tableColumn?.key) {
                        <div class="loader-style">
                          <ngx-skeleton-loader class="flex loader-line mr-60" count="1" appearance="line"></ngx-skeleton-loader>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              }
           </div>
        } @else {
                <div class="table-scroll-container inner-tables">
                <table mat-table [dataSource]="element.components || []" class="mat-elevation logs" multiTemplateDataRows>
                  @for (innerTableColumn of innerTableColumns; track innerTableColumn?.key) {
                    @if (innerTableColumn.type === 'text') {
                      <ng-container [matColumnDef]="innerTableColumn?.key">
                        <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700" [ngClass]="{'comp-name': innerTableColumn?.componentType}">
                          {{ innerTableColumn?.name | uppercase }}
                        </th>
                        <td mat-cell *matCellDef="let data" class="fw-500 fs-16">
                            <span class="fw-400 fs-16">
                            {{ data[innerTableColumn?.key] ? (innerTableColumn?.componentType ? data[innerTableColumn?.key] : (data[innerTableColumn?.key] | titlecase)) : '-'}}
                          </span>
                          @if (innerTableColumn?.componentType) {
                            <span class="comp-type ml-8 pl-8 pr-8 pb-2">{{data?.componentType || data?.stageType}}</span>
                          }
                        </td>
                      </ng-container>
                    }
                    @if (innerTableColumn.type === 'date') {
                      <ng-container [matColumnDef]="innerTableColumn?.key">
                        <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700">
                          {{ innerTableColumn?.name | uppercase }}
                        </th>
                        <td mat-cell *matCellDef="let data" class="fw-400 fs-16">
                          {{ data[innerTableColumn?.key] ? (data[innerTableColumn?.key] | date: 'dd MMM yyyy HH:mm:ss' : 'UTC') : '-' }}
                        </td>
                      </ng-container>
                    }
                    @if (innerTableColumn.type === 'duration') {
                      <ng-container [matColumnDef]="innerTableColumn?.key">
                        <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700">
                          {{ innerTableColumn?.name | uppercase }}
                        </th>

                        <td mat-cell *matCellDef="let data" class="fw-400 fs-16">
                          <span [ngClass]="data[innerTableColumn?.endKey] ? addClassDuration((data?.start | timeDuration : data?.end), data?.status) : ''" [class.p-8]="data[innerTableColumn?.endKey]">
                            {{ data[innerTableColumn?.startKey] | timeDuration : data[innerTableColumn?.endKey] }}
                          </span>
                        </td>
                      </ng-container>
                    }
                      @if (innerTableColumn.type === 'status') {
                      <ng-container [matColumnDef]="innerTableColumn?.key">
                        <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700">
                          {{ innerTableColumn?.name | uppercase }}
                        </th>
                        <td mat-cell *matCellDef="let data" class="fw-500 fs-16 runbook-status">
                          <div class="flex items-center" [ngClass]="inprogressStatus.includes(data[innerTableColumn?.key]) ? '' : (data[innerTableColumn?.key] === 'yet to start' ? 'status not-started' : 'status ' + data[innerTableColumn?.key])">
                            <span>
                              @if (!inprogressStatus.includes(data[innerTableColumn?.key]) && data[innerTableColumn?.key] !== 'yet to start') {
                                <mat-icon
                                  [svgIcon]="
                                    completedStatus.includes(data[innerTableColumn?.key])
                                    ? 'check_circle_filled':
                                    failedStatus.includes(data[innerTableColumn?.key])
                                      ? 'cancel_filled'
                                      : ''
                                  "
                                  class="icon-sm"
                                ></mat-icon>
                              } @else if (inprogressStatus.includes(data[innerTableColumn?.key]) && activityProgressService.isThresholdReached(data?.start, data?.expectedDurationMs, currentTime) && data?.health?.warning === "true" && !data?.finishTime) {
                                <mat-icon  class="cursor-pointer icon-md-1 ml-20 warn" svgIcon="warning_amber" (click)="openThresholdDialog(data)"></mat-icon>
                              } @else if(inprogressStatus.includes(data[innerTableColumn?.key]) && !data?.finishTime){
                                 <div class="progress-circle ml-20" [style.--progress]="activityProgressService.getElapsedPercent(data?.start,data?.expectedDurationMs,currentTime) + '%'"  [matTooltip]="activityProgressService.getElapsedPercent(data?.start,data?.expectedDurationMs,currentTime) + '%'" matTooltipPosition="above"></div>
                                <!-- <mat-spinner *ngIf="inprogressStatus.includes(data[innerTableColumn?.key])" diameter="16" class="mr-8 progress-color" mode="indeterminate"></mat-spinner> -->
                                 <!-- <div class="circular-progress-wrapper">
                                  <mat-spinner diameter="36" class="progress-color" mode="indeterminate"></mat-spinner>
                                  <span class="progress-percent-text">
                                    {{ activityProgressService.getElapsedPercent(data?.start, data?.expectedDurationMs, currentTime) }}%
                                  </span>
                                </div> -->
                              } @else {
                                <mat-icon
                                  svgIcon="circle" class="icon-md p-2 mr-4">
                                </mat-icon>
                              }
                            </span>
                            @if (inprogressStatus.includes(data[innerTableColumn?.key]) && !data?.finishTime) {
                              @if (activityProgressService.isThresholdReached(data?.start, data?.expectedDurationMs, currentTime) && data?.health?.warning === "true") {
                                <span class="fs-16 fw-400 ml-50 threshold-label">{{'THRESHOLD_DIALOG.TITLE' | transloco}}</span>
                              }
                              @if  (activityProgressService.getTimeRemaining(data?.start, data?.expectedDurationMs, currentTime); as timeLeft) {
                              <span class="fs-16 fw-400 ml-50 time-remaining">
                                {{ timeLeft }}
                              </span>
                            }
                            }
                          </div>
                        </td>
                      </ng-container>
                    }
                  }
                  <ng-container matColumnDef="locationDetail">
                    <td mat-cell *matCellDef="let data" [attr.colspan]="innerColumnHeaders.length">
                      <div>
                        @if (data?.location) {<span class="location-type location-tag-fixed">{{ data.location | titlecase}}</span>}
                      </div>
                    </td>
                  </ng-container>
                  <tr mat-row *matRowDef="let row; columns: ['locationDetail']; when: showLocationDetail" class="location-detail-row"></tr>
                  <tr mat-header-row *matHeaderRowDef="innerColumnHeaders"></tr>
                  <tr mat-row *matRowDef="let row; columns: innerColumnHeaders;"></tr>
                </table>
                </div>
              }
                @if (!element.components || element.components?.length === 0 && !element.innerLoading) {
                <div
                  class="rounded-b-lg rounded-t-none no-result-message text-center pt-24 pb-24 fs-16 fw-500 text-neutral-600">
                  <img src="/assets/images/no_result.svg" alt="No data found" />
                  <div class="mt-16">{{ 'INSTANCE_LIST.NO_DATA_FOUND' | transloco }}</div>
                </div>
                }
            </ng-container>
          </div>
        }
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnHeaders" sticky></tr>
    <tr mat-row *matRowDef="let row; columns: columnHeaders;"
      class="example-element-row"
      [class.example-expanded-row]="expandedElement === element"></tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
</table>
</div>

@if (!dataLoading && (!dataSource || dataSource?.length === 0) && (searchText?.length >= 0 || !searchText) && !initialCreate) {
  <div
    class="rounded-t-none no-result-message text-center py-16 fs-16 fw-500 text-neutral-600" [ngClass]="{'rounded-b-lg' : pageName !== 'activityDetails'}">
    @if (pageName === 'activityDetails') {
      <img src="/assets/images/service_not_found.png" alt="No data found" class="w-106" />
      <div class="mt-16" [innerHtml]="noDataMessage"></div>
    }
    @else{
      <img src="/assets/images/no_result.svg" alt="No data found" />
      <div class="mt-16">{{ 'INSTANCE_LIST.NO_DATA_FOUND' | transloco }}</div>
    }
  </div>
}
<!-- <div class="pt-20" *ngIf="!dataLoading && dataSource?.length > 10">
    <app-paginator [length]="dataSource?.length" [pageSizeOptions]="[5, 10, 15]"
                   [pageSize]="paginationSize" [pageIndex]="pageIndex" [rangeSize]="3" (page)="pageChanged($event)"></app-paginator>
</div> -->
}
  @if (dataLoading && showSkeletonLoader) {
    <div class="loader-section">
      <div class="instances-group loader-header flex flex-col p-16">
        <div class="flex flex-row">
          @for (tableColumn of displayColumns; track tableColumn?.key) {
            <div class="loader-style">
              <ngx-skeleton-loader class="flex loader-line mr-80" count="1" appearance="line"></ngx-skeleton-loader>
            </div>
          }
        </div>
      </div>

      @for (item of [1, 2, 3]; track $index) {
  <div class="w-100-percent">
    <div class="instances-group flex flex-col p-16">
      <div class="flex flex-row">
        @for (tableColumn of displayColumns; track tableColumn?.key) {
          <div class="loader-style">
            <ngx-skeleton-loader class="flex loader-line mr-80" count="1" appearance="line"></ngx-skeleton-loader>
          </div>
        }
      </div>
    </div>
  </div>
}
 </div>
  }
</div>
